export enum ETipoRelatorioBalancete {
    Geral = 1,
    Diario = 2,
    Detalhado = 3,
}
